import Link from "next/link";
import { Flag } from "lucide-react";
import { contentReportHref, contentReportLabel, type ContentReportContext } from "@/lib/safety/content-report";

export function ReportContentLink({ context }: { context: ContentReportContext }) {
  return <Link href={contentReportHref(context)} aria-label={`Report this ${contentReportLabel(context)}`}
    className="inline-flex min-h-11 items-center gap-1.5 rounded-sm px-2 text-xs text-text-muted hover:text-error">
    <Flag size={15} aria-hidden="true" /> Report
  </Link>;
}
